import React from "react";
import Button from "@adsk/alloy-react-button";
import { useTranslations } from "./utils";
export var SampleComponent = function () {
  var T = useTranslations().T;
  return React.createElement(
    "div",
    null,
    "Sample Component",
    React.createElement("br", null),
    T.translate("createTemplateModal.createBlank"),
    React.createElement("br", null),
    React.createElement(Button, null, T.translate("navigation.cancel"))
  );
};
